import _ from 'lodash';
import {
  fileTypeCheck,
  fileTypeCheckImagePDF,
  approvalFileType,
  fileSizeCheck,
  dynamicFileSizeCheck,
  hasfileName,
} from './fileType';

const getImageResolution = async src => {
  return await new Promise(resolve => {
    const image = new Image();
    image.onload = () => {
      let obj = {
        width: image.naturalWidth,
        height: image.naturalHeight,
      };
      resolve(obj);
    };
    image.src = src;
  });
};

const resizeDataURL = (data, fileType, wantedWidth, wantedHeight) => {
  return new Promise(async function(resolve) {
    const img = document.createElement('img');
    img.onload = function() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = wantedWidth;
      canvas.height = wantedHeight;
      ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
      const dataURI = canvas.toDataURL(`${fileType}`, 1.0);
      resolve(dataURI);
    };
    img.src = data;
  });
};

export const loadImage = (path, _canvas, func) => {
  let image = new Image();
  let ctx = _canvas.getContext('2d');
  image.onload = () => {
    ctx.drawImage(image, 0, 0);
    if (func) {
      func(_canvas.toDataURL('image/jpeg'));
    }
  };
  image.src = path;
};

export const getImageScale = (width, height) => {
  var sx = width / 1000;
  var sy = height / 650;
  var sc = sx;
  if (sy > sx) {
    sc = sy;
  }
  if (sc < 1.0) {
    sc = 1.0;
  }
  return {
    scaleX: 1 / sc,
    scaleY: 1 / sc,
  };
};

export const imageObjectSetScale = imageObject => {
  const { scaleX, scaleY } = getImageScale(
    imageObject.width,
    imageObject.height
  );
  imageObject.scaleX = scaleX;
  imageObject.scaleY = scaleY;

  // 下記チケットによる不具合修正です。
  //   BLDE_V2-9484 【現場配置計画】  場所を変更したら、背景のイメージが崩れている。
  // この修正のために上記ソース部分の
  // フロント部分の背景画像スケール処理を停止します。
  // 本来はフロント側が正しく、
  // サーバー側(SignalR側)に実装されていないのが誤っているのですが
  // 致命的な問題でもなくサーバー側の修正場所が不明なため
  // 暫定的にフロント側のコード修正で対応します。

  imageObject.top = 0;
  imageObject.left = 0;
};

export const changeImageDataToBlob = base64 => {
  // !Object.keys(base64).length this func takes a lot of memory
  if (_.isEmpty(base64)) {
    return null;
  }

  const image = base64.match(/image\/(.+);/);
  const type = image[1];
  const bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  return new Blob([buffer.buffer], { type: `image/${type}` });
};

export const resizeImageBySize = async (dataUrl, maxSize, fileType) => {
  // Gifの画像の場合は対象外となる
  if (fileType === 'image/gif') {
    return dataUrl;
  }
  // 短辺がmaxSize以下の場合はリサイズしません
  const { width, height } = await getImageResolution(dataUrl);
  if (width <= maxSize || height <= maxSize) {
    return dataUrl;
  }
  if (width < height) {
    return await resizeDataURL(
      dataUrl,
      fileType,
      maxSize,
      (height * maxSize) / width
    );
  } else {
    return await resizeDataURL(
      dataUrl,
      fileType,
      (width * maxSize) / height,
      maxSize
    );
  }
};

const ImageUtility = {
  fileTypeCheck, // return Promise
  fileTypeCheckImagePDF, // return Promise
  approvalFileType,
  fileSizeCheck, // return Promise
  dynamicFileSizeCheck,
  changeImageDataToBlob,
  resizeImageBySize,
  hasfileName, // return Promise
};

export default ImageUtility;



// WEBPACK FOOTER //
// ./src/utilities/imageUtility.js